import * as angular from 'angular';
import {IController} from 'angular';
import * as _ from "lodash";
import {SplitService} from "../../services/split-service.service";

export class BringozTagsCtrl implements IController {

  tags: any;
  maxTags: any;
  backgroundColor: string;
  isColumns: boolean = false;

  private tagsToHide: any;
  private tagsWithColor: any[]
  private tagsMap: any;
  private viewTags: any;
  private extraTagsCount: any;
  private extraTags: any;

  constructor(private deliveriesConstants, private splitService: SplitService) {

  }

  $onInit() {
    this.tagsToHide = this.splitService.getIsSite() ? (this.splitService.getTagsToHide() || []) : [];
    this.tagsWithColor = this.splitService.getIsSite() ? (this.splitService.getTagsWithColor() || []) : [];

    this.tagsMap = this.deliveriesConstants.tagsMap;
    this.viewTags = [];

    this._initTags(this.tags);
  }

  $onChanges(changes) {
    if (changes.tags && !changes.tags.isFirstChange()) {
      this.viewTags = [];
      this._initTags(this.tags);
    }
  };

  private _initTags(tags) {

    this.extraTagsCount = undefined;
    this.extraTags = undefined;
    const tagIdsToHIde = _.map(this.tagsToHide, 'id');
    const tagNamesToHIde = _.map(this.tagsToHide, 'name');
    const consoleTags = (tags || []).filter((t) => {
      return !!t?.id ? !_.includes(tagIdsToHIde, t.id) : !_.includes(tagNamesToHIde, t);
    })

    if (_.get(consoleTags, 'length')) {

      const infoTagEntity = consoleTags.map((tag) => {
        const tagEntity = this.tagsWithColor.find((t) => t.name === tag);
        return {
          name: tag,
          color: tagEntity?.color,
        }
      })

      this.viewTags = this.maxTags ? infoTagEntity.filter((item, index) => {
        return index < this.maxTags;
      }) : infoTagEntity;

      if (consoleTags.length > this.viewTags.length) {
        this.extraTagsCount = '+' + (consoleTags.length - this.viewTags.length).toString();
      }

      if (this.extraTagsCount) {
        const tagsCopy = angular.copy(consoleTags);
        this.extraTags = tagsCopy.slice(this.viewTags.length);
      }
    }
  }

}


angular
  .module('bringoz.admin.commons')
  .component('bringozTags', {
    bindings: {
      isColumns: '<?',
      tags: '<',
      maxTags: '<?',
      backgroundColor: '<?',
    },
    template: require('./bringoz-tags.html').default,
    controller: BringozTagsCtrl
  });
